// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import ReportCriteriaFooter from '../../shared/components/report-criteria-footer';
import ResponsibleDealerCriteria from './responsible-dealer-criteria';
import ResponsibleDealerReportLatestDataCriteria from './responsible-dealer-report-latest-data-criteria';

const ResponsibleDealerReportCriteria = props =>
    <div className='responsible-dealer-criteria'>
        <div className='criteria-container'>
            <div className='primary-criteria'>
                <ResponsibleDealerCriteria
                    onDealerSelect={props.onDealerSelect}
                    onSelectAllDealers={props.onSelectAllDealers}
                    selectedAccounts={props.selectedAccounts}
                    selectedDealers={props.selectedDealers}
                />
            </div>
            <div className='secondary-criteria'>
                <ResponsibleDealerReportLatestDataCriteria
                    isLatest={props.isLatest}
                    label='LATEST'
                    onLatestInputChange={props.onLatestInputChange}
                />
            </div>
        </div>
        <ReportCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            isRequired={true}
            onCriteriaReset={props.onReset}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onCreateReport}
            showExport={true}
            showReport={true}
        />
    </div>;

ResponsibleDealerReportCriteria.displayName = 'ResponsibleDealerReportCriteria';
ResponsibleDealerReportCriteria.propTypes = {
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    isLatest: PropTypes.bool.isRequired,
    model: PropTypes.string.isRequired,
    onCreateReport: PropTypes.func.isRequired,
    onDealerSelect: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired,
    onLatestInputChange: PropTypes.func.isRequired,
    onModelInputChange: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired
};

export default ResponsibleDealerReportCriteria;



// WEBPACK FOOTER //
// ./src/reports/responsible-dealer/components/responsible-dealer-report-criteria.js